export const CaptureHigherEd = {
  connect(trackingId) {
    global._cbe('create', trackingId);
  },
  logPageView() {
    global._cbe('log', 'pageview');
  },
};
